import { useAppSelector } from "@/lib/redux/hooks";

export const useProfile = () => useAppSelector(state => state.user.profile.data)